import { useEffect, useState } from 'react';

import {
    servGetPendenciasFormularioAcompanhamentoMonitoramento
} from '../servicos/servicosEmRotasPrivadas/pendencia_relatorio_acompanhamento';
import { toastErrorFromResponse } from '../util/utilitarios';

import toast from 'react-hot-toast';
import Paginador from '../componentes/Paginador';
import FiltrosPendencias from '../componentes/FiltrosPendencias';

function AcompanharPendencias() {

    console.log('### Iniciando AcompanharPendencias ###')

    const [pendenciasData, setPendenciasData] = useState(null)

    const [query, setQuery] = useState({
        statusId: null,
        blocoItemId: null,
        modeloItemId: null,
        filtroPeriodo: null,
        mesCompetencia: null,
        mesInicio: null,
        mesFim: null,
        estabelecimentoId: null,
        modoVencimento: 'none', // null | vencidas | avencer
        diasAVencer: null,
        page: 0
    })

    useEffect(() => {
        buscarPendencias(false);
    }, [query.page]);

    const buscarPendencias = async (primeiraPagina) => {

        let queryLocal = query

        queryLocal.estabelecimentoId = queryLocal.estabelecimentoId
            ? queryLocal.estabelecimentoId.id : null

        if (primeiraPagina) {
            queryLocal.page = 0
        }

        try {
            const pendenciasDaApi = await toast.promise(
                servGetPendenciasFormularioAcompanhamentoMonitoramento(queryLocal),
                { loading: 'Buscando pendências...' }
            )
            setPendenciasData(pendenciasDaApi.data)
        } catch (error) {
            console.error(error);
            toastErrorFromResponse(error);
        }

    };

    function updateFiltro(nome, valor) {
        setQuery(prev => ({
            ...prev,
            [nome]: valor
        }))
    }

    return (
        <div className='container-fluid d-flex flex-column gap-3 p-3'>

            <div className='container'>

                <FiltrosPendencias
                    filtros={query}
                    updateFiltro={updateFiltro}
                />

                <button
                    className="btn btn-primary mt-2"
                    type="button"
                    onClick={() => buscarPendencias(true)}
                >
                    BUSCAR
                </button>

            </div>

            {pendenciasData &&
                <div>
                    <table className="table">
                        <thead>
                            <tr>
                                <th scope="col">Estabelecimento</th>
                                <th scope="col">Pergunta</th>
                                <th scope="col">Mês Referência</th>
                                <th scope="col">Data Previsão Resolução</th>
                            </tr>
                        </thead>
                        <tbody>
                            {pendenciasData.pendencias.map((pendencia) => (
                                <tr key={pendencia.pendencia_id}>
                                    <td>{pendencia.estabelecimento}</td>
                                    <td>{pendencia.descricao_modelo_item}</td>
                                    <td>{pendencia.mes_referencia}</td>
                                    <td>{pendencia.data_previsao_resolucao}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <Paginador
                        page={query.page}
                        setPage={(e) => updateFiltro('page', e)}
                        itemsPerPage={pendenciasData.tamanho_pagina}
                        totalItems={pendenciasData.total}
                    />
                </div>
            }

        </div >

    );
}

export default AcompanharPendencias
